"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentFctEventType = void 0;
/**
 * Used for V2 Events
 * NOTE [jdao]: These should be replaced by @mothership/events eventually.
 */
var ShipmentFctEventType;
(function (ShipmentFctEventType) {
    // Facts
    ShipmentFctEventType["ShipmentCreated"] = "ShipmentCreated";
    ShipmentFctEventType["ShipmentUpdated"] = "ShipmentUpdated";
    ShipmentFctEventType["ShipmentDeleted"] = "ShipmentDeleted";
    ShipmentFctEventType["ShipmentStatusUpdated"] = "ShipmentStatusUpdated";
    ShipmentFctEventType["ShipmentProNumberChanged"] = "ShipmentProNumberChanged";
})(ShipmentFctEventType = exports.ShipmentFctEventType || (exports.ShipmentFctEventType = {}));
//# sourceMappingURL=ShipmentEventType.js.map